import './hero.css';

const Hero = () => {
  return (
    <section className="hero" aria-label="Privatpraxis Maliha Malik">
      <h1>
        Privatpraxis für Psychiatrie und Psychotherapie
        <br />
        Maliha Malik
      </h1>
      <div>Fachärztin für Psychiatrie und Psychotherapie</div>
    </section>
  );
};

export default Hero;
